import Compressor from 'compressorjs';

export const compressImage = (file, options) =>
  new Promise((resolve, reject) => {
    new Compressor(file, {
      ...options,
      success: resolve,
      error: reject,
    });
  });